import React from 'react'

// Compoments
import { Button } from '@sketch/components'

interface ShareYourCreationsButtonProps {
  dimmed: boolean
}

const ShareYourCreationsButton = (props: ShareYourCreationsButtonProps) => {
  const { dimmed } = props
  return (
    <Button variant={dimmed ? 'tertiary' : 'primary-untinted'}>
      Share Your Creations
    </Button>
  )
}

export default ShareYourCreationsButton
